/* eslint-disable ember/classic-decorator-hooks, ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-observers */
import Helper from '@ember/component/helper';
import { service } from '@ember/service';
import { addObserver, removeObserver } from '@ember/object/observers';
import { isEmpty } from '@ember/utils';

// Returns true if currentRouteName exactly matches routeName,
// or is a child route at any depth (e.g. routeName + '.something').
//
// Optional third argument: a query params hash (from `(hash key=value)`).
// When provided, the current URL must also contain matching query params.
// A null/empty value means the param must be absent from the URL (i.e. at default).
//
// Example: (route-active "admin.import" currentRouteName (hash type="staff"))
export default class RouteActive extends Helper {
  @service
  router;

  init() {
    super.init(...arguments);
    // Recompute when query params change without a route change
    addObserver(this, 'router.currentURL', this, 'recompute');
  }

  willDestroy() {
    removeObserver(this, 'router.currentURL', this, 'recompute');
    super.willDestroy(...arguments);
  }

  compute([routeName, currentRouteName, queryParams]) {
    if (isEmpty(routeName) || isEmpty(currentRouteName)) {
      return false;
    }

    let routeMatches =
      currentRouteName === routeName ||
      currentRouteName.startsWith(routeName + '.');

    if (!routeMatches) return false;
    if (!queryParams) return true;

    let currentURL = this.get('router.currentURL') || '';
    let search = currentURL.includes('?') ? currentURL.split('?')[1] : '';
    let params = new URLSearchParams(search);

    return Object.entries(queryParams).every(([key, value]) => {
      if (isEmpty(value)) {
        // Empty/null means the param should be absent (i.e. at its default value)
        return !params.has(key) || params.get(key) === '';
      }
      return params.get(key) === String(value);
    });
  }
}
